import Cookies from 'js-cookie';

export const setCookie = (name: string, value: string) => {
  Cookies.set(name, value, {
    secure: true,
    sameSite: 'Strict',
  });
};